import { elapsed, timeStampNow } from '@datadog/browser-core';
import { trackCumulativeLayoutShift } from './trackCumulativeLayoutShift';
import { trackInteractionToNextPaint } from './trackInteractionToNextPaint';
import { trackLoadingTime } from './trackLoadingTime';
import { trackScrollMetrics } from './trackScrollMetrics';
export function trackCommonViewMetrics(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    const commonViewMetrics = {};
    let hasManualLoadingTime = false;
    let viewEnded = false;
    const { stop: stopLoadingTimeTracking, setLoadEvent } = trackLoadingTime(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, viewStart, (newLoadingTime) => {
        if (!hasManualLoadingTime) {
            commonViewMetrics.loadingTime = newLoadingTime;
            scheduleViewUpdate();
        }
    });
    const { stop: stopScrollMetricsTracking } = trackScrollMetrics(configuration, viewStart, (newScrollMetrics) => {
        commonViewMetrics.scroll = newScrollMetrics;
    });
    const { stop: stopCLSTracking } = trackCumulativeLayoutShift(configuration, viewStart.relative, (cumulativeLayoutShift) => {
        commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
        scheduleViewUpdate();
    });
    const { stop: stopINPTracking, getInteractionToNextPaint, setViewEnd: setINPViewEnd, } = trackInteractionToNextPaint(configuration, viewStart.relative, loadingType);
    return {
        stop: () => {
            stopLoadingTimeTracking();
            stopCLSTracking();
            stopScrollMetricsTracking();
        },
        stopINPTracking,
        setLoadEvent,
        setViewEnd: (viewEndTime) => {
            viewEnded = true;
            setINPViewEnd(viewEndTime);
        },
        getCommonViewMetrics: () => {
            commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
            return commonViewMetrics;
        },
        setLoadingTime: (callTimestamp) => {
            if (viewEnded) {
                return;
            }
            const loadingTime = elapsed(viewStart.timeStamp, callTimestamp !== null && callTimestamp !== void 0 ? callTimestamp : timeStampNow());
            if (!hasManualLoadingTime) {
                stopLoadingTimeTracking();
            }
            hasManualLoadingTime = true;
            commonViewMetrics.loadingTime = loadingTime;
            scheduleViewUpdate();
        },
    };
}
//# sourceMappingURL=trackCommonViewMetrics.js.map